import type { Message } from '@nexo/types';
import { useSyncExternalStore } from 'react';

/** Message being answered inline, per conversation (shown above the composer). */
const replying = new Map<string, Message>();
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const replyStore = {
  set(message: Message) {
    replying.set(message.channelId, message);
    emit();
    // Let the composer take the focus.
    window.dispatchEvent(new CustomEvent('nexo:focus-composer', { detail: message.channelId }));
  },
  clear(channelId: string) {
    if (replying.delete(channelId)) emit();
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export const useReplyingTo = (channelId: string) =>
  useSyncExternalStore(replyStore.subscribe, () => replying.get(channelId) ?? null);

/** Scrolls to a message of the timeline (if loaded) and flashes it. */
export function jumpToMessage(messageId: string): boolean {
  const element = document.getElementById(`message-${messageId}`);
  if (!element) return false;
  element.scrollIntoView({ block: 'center', behavior: 'smooth' });
  element.classList.add('nexo-flash');
  setTimeout(() => element.classList.remove('nexo-flash'), 1600);
  return true;
}
